/** Calendar day of a YYYY-MM-DD (optionally with time) string. Avoids dates.ts (cycle with utils). */
const parseYmd = d => {
  const ymd = d.split('T')[0].split(' ')[0];
  const [year, month, day] = ymd.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const isNoteInDateRange = (fromDate, toDate) => note => {
  var _ref, _note$visitdatetime;

  const dateField = (_ref = (_note$visitdatetime = note.visitdatetime) !== null && _note$visitdatetime !== void 0 ? _note$visitdatetime : note.notedatetime) !== null && _ref !== void 0 ? _ref : note.noteddatetime;

  if (!dateField) {
    return false;
  }

  const noteDate = parseYmd(dateField);
  return noteDate >= parseYmd(fromDate) && noteDate <= parseYmd(toDate);
};
/**
 * Filter a keyed notes map (entityKey → progressNote[]) to notes within
 * [fromDate, toDate] (inclusive). When either bound is missing, returns the
 * map unchanged.
 */

export const filterNotesByDateRange = (notesMap, fromDate, toDate) => {
  if (!notesMap || typeof notesMap !== 'object') {
    return notesMap;
  }

  if (!fromDate || !toDate) {
    return notesMap;
  }

  const predicate = isNoteInDateRange(fromDate, toDate);
  return Object.fromEntries(Object.entries(notesMap).map(([key, notes]) => [key, Array.isArray(notes) ? notes.filter(predicate) : notes]));
};
/**
 * Widget-tagged notes are fetched for the whole patient. Only "Notes for date
 * range" (notesMode === 'dateRange') should restrict them to the print window.
 * "All notes" leaves the map unchanged even when fromDate/toDate are set.
 */

export const filterWidgetNotesForPrint = (notesMap, printConfig, fromDate, toDate) => {
  if ((printConfig === null || printConfig === void 0 ? void 0 : printConfig.notesMode) !== 'dateRange') {
    return notesMap;
  }

  return filterNotesByDateRange(notesMap, fromDate, toDate);
};